import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as messages from '@/lang/en-US.json';
import axios from 'axios';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  silentTranslationWarn: process.env.VUE_APP_ENVIRONMENT === 'production' ? true : false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    "en-US": messages.default, // set locale messages
  },
});

const loadedLanguages = [ 'en-US' ]; // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync (lang) {
  if (lang === 'en') {
    lang = 'en-US';
  }

  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  axios.defaults.baseURL = process.env.VUE_APP_ROOT || '';
  // If the language hasn't been loaded yet
  axios({
    method: 'get',
    url: `./lang/${lang}.json`,
  }).then(response => {
    i18n.setLocaleMessage(lang, response.data);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  }).catch(err => {
    console.error(err);
  });
  axios.defaults.baseURL = process.env.VUE_APP_API_ROOT || '';

}